module.exports = __webpack_public_path__ + "img/right-arrow.be6adb76.svg";